// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Rectangle } from "../../Commons/Geometry.ts";
import { buttonsPopupHandler } from "../../Utils/AppHandlers.js";
import { TerceraButtonsPopupTemplate } from "../../templates.js";
import { ContainerControl } from "./ContainerControl.js";
import { TerceraButton } from "./TerceraButton.js";
import { TerceraMenu } from "./TerceraMenu.js";

export let TerceraButtonsPopup = ContainerControl.extend({
    el: 'buttonsPopupContainer',
    template: TerceraButtonsPopupTemplate,
    data: function ()
    {
        return {
            visible: false,
            popupItems: null
        };
    }
});

TerceraButtonsPopup.prototype.getType = function () { return 'TerceraButtonsPopup'; };

TerceraButtonsPopup.prototype.oninit = function ()
{
    ContainerControl.prototype.oninit.apply(this);
    this.onButtonClicked = this.onButtonClicked.bind(this);
};

TerceraButtonsPopup.prototype.getClientPanel = function ()
{
    return '.js-buttons-popup';
};

TerceraButtonsPopup.prototype.onButtonClicked = function ()
{
    this.Hide();
};

TerceraButtonsPopup.prototype.onItemClicked = function (item)
{
    if (item && item.event)
        item.event(item.type);
};

TerceraButtonsPopup.prototype.Hide = function ()
{
    this.removeAllControls();
    this.set('visible', false);
    this.lostFocus();
};

TerceraButtonsPopup.show = function (items, x, y, maxColumnsCount)
{
    if (typeof _buttonsPopup.el !== 'object')
    {
        _buttonsPopup.el = document.getElementById(_buttonsPopup.el)
        _buttonsPopup.render()
    }
    if (!items || !items.length)
        return;

    if (typeof _buttonsPopup.el !== 'object')
    {
        _buttonsPopup.el = document.getElementById(_buttonsPopup.el)
        _buttonsPopup.render()
    }

    let rowsCount = Math.ceil(items.length / maxColumnsCount);
    let columnsCount = items.length < maxColumnsCount ? items.length : maxColumnsCount;
    let margin = 3;
    let sizeBtn = 30;

    let w = margin + columnsCount * (sizeBtn + margin);
    let h = margin + rowsCount * (sizeBtn + margin);
    let newLocation = TerceraMenu.CorrectPopupLocation(new Rectangle(x, y, w, h));

    // Positioning.
    _buttonsPopup.set({
        left: newLocation.newX,
        top: newLocation.newY,
        width: w,
        visible: true,
        popupItems: items
    });
};


let _buttonsPopup = new TerceraButtonsPopup();
buttonsPopupHandler.set = (key) => { return _buttonsPopup.set(key) }
buttonsPopupHandler.get = (key) => { return _buttonsPopup.get(key) }
buttonsPopupHandler.Hide = _buttonsPopup.Hide.bind(_buttonsPopup)
buttonsPopupHandler.onButtonClicked = _buttonsPopup.onButtonClicked.bind(_buttonsPopup)
buttonsPopupHandler.addControl = _buttonsPopup.addControl.bind(_buttonsPopup)    